/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Assistant from './Assistant/index'
import Change from './Change/index'
import ChangeAction from './ChangeAction/index'
import Provider from './Provider/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/AssistantAndProvider/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--ml-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Horizontal}`}
>
<Provider
  viewPath={`${viewPath}/Provider`}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="/"
 marginLeft={dtSpaceXxs}
 marginRight={dtSpaceXxs}
 color={dtColorsNeutral700}
/>
<Assistant
  viewPath={`${viewPath}/Assistant`}
/>
<ChangeAction
  viewPath={`${viewPath}/ChangeAction`}
/>
</div>
<Change
  viewPath={`${viewPath}/Change`}
/>
{children}
</React.Fragment>)
}